import { RequestStatus } from 'clickNgo/configs/service/common'

import { IExtendedPartnerDataState } from './models'

export const INITIAL_STATE: IExtendedPartnerDataState = {
  base: {
    data: new Map([]),
    status: RequestStatus.NONE,
    message: '',
  },
  created: new Map([]),
  modified: new Map([]),
  deleted: new Map([]),
}

export const NAME = 'extendedPartnerData'

export const GET_EXTENDED_PARTNER_DATA_BY_ID = `${NAME}/getExtendedPartnerDataById`

export const INIT_EXTENDED_PARTNER_DATA_ACTION = `${NAME}/initEPDataAction`
